import { FC, useContext, useEffect, useState } from 'react';

import { AutoComplete, Form, FormItemProps } from 'antd';

import { GenericDataFormContext } from '../../../../contexts';

import {
  CuentasBancaria,
  PaymentMethodForms,
  SelectOption,
  TarjetasDelAsegurado,
} from '../../../../../../../../../shared/interfaces';
import { PAYMENT_FORM_CODE } from '../../../../interfaces';

interface SearchBarPaymentProps {
  formProps?: FormItemProps;
  getCompanySelected?: () => void;
  handlerOnChange: (value: string) => void;
  handleSelect: () => void;
  paymentMethodSelected: PaymentMethodForms;
}

export const SearchBarPayment: FC<SearchBarPaymentProps> = ({
  formProps,
  getCompanySelected = () => {},
  handlerOnChange,
  handleSelect,
  paymentMethodSelected,
}) => {
  const {
    paymentMethodSectionForm,
    listCreditCardInsured,
    listBankAccountByInsured,
  } = useContext(GenericDataFormContext);

  const [inputValue, setInputValue] = useState<string>('');

  const [options, setOptions] = useState<Array<SelectOption>>([]);

  useEffect(() => {
    if (
      listBankAccountByInsured &&
      listBankAccountByInsured.cuentasBancarias.length > 0
    ) {
      const opcionesTransformadas: Array<SelectOption> =
        listBankAccountByInsured.cuentasBancarias.map(
          (cuenta: CuentasBancaria) => ({
            label: cuenta.numeroCBU,
            value: cuenta.numeroCBU,
          })
        );
      setOptions(opcionesTransformadas);
    }

    if (
      listCreditCardInsured &&
      listCreditCardInsured.tarjetasDelAsegurado.length > 0
    ) {
      const opcionesTransformadas: Array<SelectOption> =
        listCreditCardInsured.tarjetasDelAsegurado.map(
          (tarjeta: TarjetasDelAsegurado) => ({
            label: tarjeta.numeroTarjeta,
            value: tarjeta.numeroTarjeta,
          })
        );
      setOptions(opcionesTransformadas);
    }
  }, [listBankAccountByInsured, listCreditCardInsured, setOptions]);

  useEffect(() => {
    if (
      listBankAccountByInsured &&
      paymentMethodSectionForm?.getFieldValue('cbuNumber') &&
      (
        paymentMethodSelected?.codigoFormaDePago === PAYMENT_FORM_CODE.DEBITO_BANCARIO_CAJA_AHORRO ||
        paymentMethodSelected?.codigoFormaDePago === PAYMENT_FORM_CODE.DEBITO_BANCARIO_CUENTA_CORRIENTE
      )
    ) {
      setInputValue(paymentMethodSectionForm?.getFieldValue('cbuNumber'));
      paymentMethodSectionForm?.setFieldValue('cardNumber', null);
      paymentMethodSectionForm?.setFieldValue('companyCreditCard', null);
      paymentMethodSectionForm?.setFieldValue('expiration', null);
    }

    if (
      listCreditCardInsured &&
      paymentMethodSectionForm?.getFieldValue('cardNumber') &&
      paymentMethodSelected?.codigoFormaDePago ===
        PAYMENT_FORM_CODE.TARJETA_CREDITO
    ) {
      setInputValue(paymentMethodSectionForm?.getFieldValue('cardNumber'));
      paymentMethodSectionForm?.setFieldValue('cbuNumber', null);
      getCompanySelected();
    }
  }, [
    listBankAccountByInsured,
    listCreditCardInsured,
    paymentMethodSectionForm,
    getCompanySelected,
    paymentMethodSelected,
  ]);

  const filterOptions = (inputValue: string, option?: SelectOption) =>
    option?.label?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

  return (
    <Form.Item {...formProps}>
      <AutoComplete
        filterOption={filterOptions}
        onChange={(value) => {
          setInputValue(value);
          handlerOnChange(value);
        }}
        onSelect={(value) => {
          setInputValue(value);
          handleSelect();
        }}
        options={options}
        placeholder=''
        value={inputValue}
      />
    </Form.Item>
  );
};
